/*
 * @Description: 项目文件路径
 * @Author: zml
 * @Date: 2022-12-29 17:18:10
 * @LastEditors: xie
 * @LastEditTime: 2024-07-31 15:25:51
 */
export default {
  components: {
    /**
     * 模板1
     * themeTemplateOne
     */
    contactDetailOne: () => import('@/components/themeTemplateOne/page/detail/index'),
    aboutDetailOne: () => import('@/components/themeTemplateOne/page/detail/index'),
    pageCartOne: () => import('@/components/themeTemplateOne/page/cart/index'),
    pageHomeOne: () => import('@/components/themeTemplateOne/page/home'),
    pageOrderDetailOne: () => import('@/components/themeTemplateOne/page/order/detail'),
    pageOrderOne: () => import('@/components/themeTemplateOne/page/order/index'),
    pageProDetailOne: () => import('@/components/themeTemplateOne/page/product/proDetail.vue'),
    pageProductOne: () => import('@/components/themeTemplateOne/page/product/index.vue'),
    pageAddressOne: () => import('@/components/themeTemplateOne/page/address/index'),
    pageLoginOne: () => import('@/components/themeTemplateOne/page/login/index'),
  }
}
